import { defineMessages } from 'react-intl';

import { sharedMessages } from '@app/translations/sharedMessages';

export const publicationDetailsNoteTypeMessages = defineMessages({
  'Language note': {
    id: 'instanceNoteTypes.languageNote',
    defaultMessage: 'Language note',
  },
  'Accessibility note': {
    id: 'instanceNoteTypes.accessibility',
    defaultMessage: 'Accessibility',
  },
});

export const contentsSummaryNoteTypeMessages = defineMessages({
  Summary: { id: 'instanceNoteTypes.summary', defaultMessage: 'Summary' },
  'General note': {
    id: 'instanceNoteTypes.generalNote',
    defaultMessage: 'Notes',
  },
  'Formatted Contents Note': {
    id: 'instanceNoteTypes.contentNote',
    defaultMessage: 'Content notes',
  },
  'Bibliography note': {
    id: 'instanceNoteTypes.bibliographicNote',
    defaultMessage: 'Bibliographic notes',
  },
  'Local notes': {
    id: 'instanceNoteTypes.localNote',
    defaultMessage: 'Local notes',
  },
});

export const additionalInformationNoteTypeMessages = defineMessages({
  'Linking Entry Complexity note': {
    id: 'instanceNoteTypes.linkingEntry',
    defaultMessage: 'Linking entry',
  },
  'Reproduction note': {
    id: 'instanceNoteTypes.reproduction',
    defaultMessage: 'Reproduction',
  },
  'Additional Physical Form Available note': {
    id: 'instanceNoteTypes.additionalForms',
    defaultMessage: 'Additional forms',
  },
  'Restrictions on Access note': {
    id: 'instanceNoteTypes.restrictionsOnAccess',
    defaultMessage: 'Restrictions on access',
  },
  'Participant or Performer note': {
    id: 'instanceNoteTypes.participantPerformer',
    defaultMessage: 'Participant/performer',
  },
  'Biographical or Historical Data': {
    id: 'instanceNoteTypes.biographicalHistoricalData',
    defaultMessage: 'Biographical or historical data',
  },
  'Date / time and place of an event note': {
    id: 'instanceNoteTypes.dateLocation',
    defaultMessage: 'Date and location',
  },
  'Target Audience note': {
    id: 'instanceNoteTypes.targetAudience',
    defaultMessage: 'Target audience',
  },
  'Geographic Coverage note': {
    id: 'instanceNoteTypes.geographicCoverage',
    defaultMessage: 'Geographic coverage',
  },
  'Issuing Body note': {
    id: 'instanceNoteTypes.issuingBody',
    defaultMessage: 'Issuing body',
  },
  'Dissertation note': {
    id: 'instanceNoteTypes.dissertation',
    defaultMessage: 'Dissertation',
  },
  'Preferred Citation of Described Materials note': {
    id: 'instanceNoteTypes.preferredCitationOfDescribedMaterials',
    defaultMessage: 'Preferred citation of described materials',
  },
  'Former Title Complexity note': {
    id: 'instanceNoteTypes.formerTitle',
    defaultMessage: 'Former title',
  },
  'Numbering peculiarities note': {
    id: 'instanceNoteTypes.numberingPeculiarities',
    defaultMessage: 'Numbering peculiarities',
  },
  'Supplement note': {
    id: 'instanceNoteTypes.supplement',
    defaultMessage: 'Supplement',
  },
  'Original Version note': {
    id: 'instanceNoteTypes.originalVersion',
    defaultMessage: 'Original version',
  },
  'Source of Description note': {
    id: 'instanceNoteTypes.sourceOfDescription',
    defaultMessage: 'Source of description',
  },
  'Data quality note': {
    id: 'instanceNoteTypes.dataQuality',
    defaultMessage: 'Data quality',
  },
  'Type of computer file or data note': {
    id: 'instanceNoteTypes.computerFileType',
    defaultMessage: 'Computer file type',
  },
  'System Details note': {
    id: 'instanceNoteTypes.systemDetail',
    defaultMessage: 'System detail',
  },
  'Entity and Attribute Information note': {
    id: 'instanceNoteTypes.entityAndAttributeInformation',
    defaultMessage: 'Entity and attribute information',
  },
  'Cumulative Index / Finding Aides notes': {
    id: 'instanceNoteTypes.findingAids',
    defaultMessage: 'Finding Aids notes',
  },
  'Information About Documentation note': {
    id: 'instanceNoteTypes.informationAboutDocumentation',
    defaultMessage: 'Information about documentation',
  },
  'Immediate Source of Acquisition note': {
    id: 'instanceNoteTypes.immediateSourceOfAcquisition',
    defaultMessage: 'Immediate source of acquisition',
  },
  'Ownership and Custodial History note': {
    id: 'instanceNoteTypes.ownershipAndCustodialHistory',
    defaultMessage: 'Ownership and custodial history',
  },
  'Location of Originals / Duplicates note': {
    id: 'instanceNoteTypes.locationOfOriginals',
    defaultMessage: 'Location of originals',
  },
  'Location of Other Archival Materials note': {
    id: 'instanceNoteTypes.locationOfOtherArchivalMaterials',
    defaultMessage: 'Location of other archival materials',
  },
  'Exhibitions note': {
    id: 'instanceNoteTypes.exhibitions',
    defaultMessage: 'Exhibitions',
  },
  'Copyright status': {
    id: 'instanceNoteTypes.copyrightStatus',
    defaultMessage: 'Copyright status',
  },
  'Accumulation and Frequency of Use note': {
    id: 'instanceNoteTypes.accumulationAndFrequency',
    defaultMessage: 'Accumulation and frequency',
  },
  'Action note': {
    id: 'instanceNoteTypes.actionNote',
    defaultMessage: 'Action note',
  },
  'Awards note': { id: 'instanceNoteTypes.awards', defaultMessage: 'Awards' },
  'Binding Information note': {
    id: 'instanceNoteTypes.bindingInformation',
    defaultMessage: 'Binding information',
  },
  'Cartographic Mathematical Data': {
    id: 'instanceNoteTypes.cartographicMathematical',
    defaultMessage: 'Cartographic mathematical data',
  },
  'Case File Characteristics note': {
    id: 'instanceNoteTypes.caseFileCharacteristics',
    defaultMessage: 'Case file characteristics',
  },
  'Citation / References note': {
    id: 'instanceNoteTypes.citationsReferences',
    defaultMessage: 'Citations/references',
  },
  'Copy and Version Identification note': {
    id: 'instanceNoteTypes.copyAndVersionIdentification',
    defaultMessage: 'Copy and version identification',
  },
  'Creation / Production Credits note': {
    id: 'instanceNoteTypes.creationProductionCredits',
    defaultMessage: 'Creation/production credits',
  },
  'Funding Information Note': {
    id: 'instanceNoteTypes.fundingInformation',
    defaultMessage: 'Funding information',
  },
  'Methodology note': {
    id: 'instanceNoteTypes.methodology',
    defaultMessage: 'Methodology',
  },
  'Publications About Described Materials note': {
    id: 'instanceNoteTypes.publications',
    defaultMessage: 'Publications about described materials',
  },
  'Scale note for graphic material': {
    id: 'instanceNoteTypes.graphicMaterial',
    defaultMessage: 'Scale note for graphic material',
  },
  'Study Program Information note': {
    id: 'instanceNoteTypes.studyProgramInformation',
    defaultMessage: 'Study program information',
  },
  'Type of report and period covered note': {
    id: 'instanceNoteTypes.typeOfReportAndPeriodCovered',
    defaultMessage: 'Type of report and period covered',
  },
  'With note': {
    id: 'instanceNoteTypes.withNote',
    defaultMessage: 'With note',
  },
  'Terms Governing Use and Reproduction note': sharedMessages.termsOfUse,
});
